class HCAllCategories extends HTMLElement {
  connectedCallback() {
    if (this.cleanup) return;
    const render = () => {
      const nav = this.querySelector('nav');
      if (!nav) return;
      const links = [...document.querySelectorAll('.hc-category-navigation .hc-department-links > a')];
      const fragment = document.createDocumentFragment();
      const seen = new Set();
      for (const source of links) {
        const url = new URL(source.href, location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/collections/') || /\/collections\/all\/?$/.test(url.pathname)) continue;
        url.hash = 'products';
        const href = url.pathname + url.search + url.hash;
        if (seen.has(href)) continue;
        seen.add(href);
        const link = document.createElement('a');
        link.href = href;
        link.textContent = source.textContent.trim();
        fragment.append(link);
      }
      nav.replaceChildren(fragment);
      this.hidden = !seen.size;
    };
    render();
    document.addEventListener('shopify:section:load', render);
    this.cleanup = () => document.removeEventListener('shopify:section:load', render);
  }
  disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
}
if (!customElements.get('hc-all-categories')) customElements.define('hc-all-categories', HCAllCategories);
